import {
  Call,
  CallingState,
  StreamVideoClient,
  User,
} from "@stream-io/video-client";
import { useCallback, useRef, useState } from "react";
import { isTeacher } from "../../../../hooks/utils";

const useStreamIO = ({
  uid,
  token,
  callId,
}: {
  uid: string;
  token: string;
  callId: string;
}) => {
  const [isMuted, setIsMuted] = useState<boolean | null>(true);
  const [isMicLoading, setIsMicLoading] = useState<boolean>(false);
  const callRef = useRef<Call>(null);
  const apiKey = "qznwcm7c72aw";
  const user: User = { id: uid, type: "authenticated" };

  const joinCall = useCallback(async () => {
    try {
      console.log("Joining call...", { uid, token, callId, apiKey, user });
      const client = new StreamVideoClient({ apiKey, token, user });
      callRef.current = client.call("livestream", callId);
      // callRef.current = client.call("development", callId);
      await callRef?.current.microphone.disable();
      await callRef?.current.join({ create: true });

      callRef.current.state.participants$.subscribe((participants) => {
        participants.forEach((participant) => {
          if (participant.isLocalParticipant) return;
          let audioElement = document.getElementById("my-audio-element");
          if (!audioElement) {
            audioElement = document.createElement("audio");
            audioElement.id = "my-audio-element";
            document.body.appendChild(audioElement);
          }
          callRef?.current?.bindAudioElement(
            audioElement as HTMLAudioElement,
            participant.sessionId,
            "audioTrack"
          );
        });
      });

      callRef.current.microphone.state.status$.subscribe((status) => {
        console.log("Call mic status:", status);
        setIsMuted(status !== "enabled");
      });

      isTeacher() && (await callRef?.current?.goLive());

      console.log("Call joined successfully");
      console.log("Call ID:", callRef?.current.id);
      console.log("Call Type:", callRef?.current.type);
      console.log("Call State:", callRef?.current.state);
    } catch (error) {
      console.error("Error joining call:", error);
    }
  }, [callId]);

  const leaveCall = useCallback(async () => {
    if (callRef?.current?.state?.callingState !== CallingState.JOINED) return;
    await callRef?.current?.leave();
  }, [callId]);

  const endCall = useCallback(async () => {
    if (callRef?.current?.state?.callingState !== CallingState.JOINED) return;
    await callRef?.current?.endCall();
  }, [callId]);

  const setMicMuted = useCallback(
    async (enforcedValue?: boolean) => {
      if (callRef?.current?.state?.callingState !== CallingState.JOINED) return;
      setIsMicLoading(true);

      if (enforcedValue === true) {
        await callRef?.current?.microphone.enable();
      } else if (enforcedValue === false) {
        await callRef?.current?.microphone.disable();
      } else {
        await callRef?.current?.microphone.toggle();
      }

      setIsMicLoading(false);
    },
    [callId]
  );

  return {
    isMuted,
    isMicLoading,
    isRTCStarted: callRef?.current?.state?.callingState === CallingState.JOINED,
    setMicMuted,
    joinCall,
    leaveCall,
    endCall,
  };
};

export default useStreamIO;
